import { ReactNode } from 'react';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import { Variant } from '@mui/material/styles/createTypography';
import { SxProps } from '@mui/system/styleFunctionSx';
import { CenterPositionedCol } from 'components/flex-containers';
import { Text } from 'components/Text';

export interface Props {
  title?: string;
  titleVariant?: Variant;
  subtitle?: string;
  sx?: SxProps;
  children: ReactNode;
}

const CardWrapper = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  marginBottom: 32,
  padding: '12px 18px 18px 18px',
  [theme.breakpoints.up('sm')]: {
    padding: '18px 32px 32px 32px'
  }
}));

export const ContentCard = ({
  title,
  titleVariant,
  subtitle,
  sx,
  children
}: Props) => {
  return (
    <CardWrapper sx={sx}>
      {title && (
        <CenterPositionedCol sx={{ pb: 1, whiteSpace: 'nowrap' }}>
          <Text variant={titleVariant ?? 'h6'}>{title}</Text>
          {subtitle && (
            <Text variant="body2" sx={{ fontSize: '0.75rem' }}>
              {subtitle}
            </Text>
          )}
        </CenterPositionedCol>
      )}
      {children}
    </CardWrapper>
  );
};
